import React, { useCallback } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { InputGroup, Input, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';

import { searchOrders } from 'Redux/ducks/orders';

const messages = defineMessages({
  placeholder: {
    id: 'order-search.placeholder',
    defaultMessage: 'Search for a specific game',
  },
});

const OrderSearch = () => {
  const dispatch = useDispatch();

  const handleChange = useCallback((event) => {
    const { value } = event.target;
    setTimeout(() => {
      dispatch(searchOrders(value));
    }, 200);
  }, [dispatch]);

  const { formatMessage } = useIntl();
  return (
    <div className="order-search">
      <InputGroup className="mb-4">
        <Input
          aria-label="order-search"
          type="search"
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck="false"
          enterKeyHint="search"
          placeholder={formatMessage(messages.placeholder)}
          onChange={handleChange}
        />
        <div className="input-group-append">
          <Button color="primary">
            <FontAwesomeIcon icon={faMagnifyingGlass} title="Search" />
          </Button>
        </div>
      </InputGroup>
    </div>
  );
};

export default OrderSearch;
